import { typography } from "@src/core/styles";
import styled from "styled-components";
import { LogComponentProps } from "./components/log-component/log-component.types";

export const FormContainer = styled.div<LogComponentProps>`
  width: 100%;

  display: flex;
  flex-direction: ${({ formType, formMethod }) =>
    formType === "routes" && formMethod === "update" ? "row" : "column"};
  margin-left: 24px;

  & > div:first-of-type {
    flex-grow: 1;
  }

  & form {
    padding-right: 24px;
    padding-bottom: 48px;
    max-width: 696px;
  }
`;

export const RoutePageTitle = styled.div`
  ${typography.display_small};
`;
